import React from 'react';
import { Crown } from 'lucide-react';

export function CharacterSheetMockup() {
  return (
    <div className="landing-mockup-card">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-amber-600 to-red-700 flex items-center justify-center">
          <Crown className="h-4 w-4 text-white" />
        </div>
        <div>
          <div className="font-cinzel text-xs font-bold">Thalion Elvenstar</div>
          <div className="text-[10px] text-muted-foreground">Elfe — Rôdeur Niv. 7</div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-1.5 mb-3">
        {[
          { label: 'FOR', val: 14, mod: '+2' },
          { label: 'DEX', val: 18, mod: '+4' },
          { label: 'CON', val: 12, mod: '+1' },
          { label: 'INT', val: 10, mod: '+0' },
          { label: 'SAG', val: 16, mod: '+3' },
          { label: 'CHA', val: 8, mod: '-1' },
        ].map((stat) => (
          <div key={stat.label} className="text-center p-1.5 rounded bg-muted/50 border border-border/30">
            <div className="text-[9px] text-muted-foreground font-bold">{stat.label}</div>
            <div className="text-sm font-bold font-cinzel">{stat.val}</div>
            <div className="text-[10px] text-primary font-mono">{stat.mod}</div>
          </div>
        ))}
      </div>
      <div className="flex gap-2 text-[10px]">
        <div className="flex-1 bg-red-500/10 border border-red-500/20 rounded px-2 py-1 text-center">
          <div className="text-red-400 font-bold">PV 45/45</div>
        </div>
        <div className="flex-1 bg-blue-500/10 border border-blue-500/20 rounded px-2 py-1 text-center">
          <div className="text-blue-400 font-bold">CA 16</div>
        </div>
      </div>
    </div>
  );
}
